import { useState } from "react";
import MenuOff from "../../assets/icon/menu-off.png";
import MenuOn from "../../assets/icon/menu-on.png";

export default function MenuButton({ toggleSidebar }) {
  const [hover, setHover] = useState(false);

  return (
    <img
      draggable={false}
      src={hover ? MenuOn : MenuOff}
      alt="menu"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={toggleSidebar}
      style={{
        cursor: "pointer",
        width: "32px",
        height: "32px",
        display: "block",
      }}
    />
  );
}
